import { getConfigurationFilters } from '@app/plp/utils/pageUtils';
import { Configure } from 'react-instantsearch';

export type ConfigureProps = {
    preFilters: string[];
    preFilterLogic: string;
    algoliaCategoryPath: string;
};

export default function ConfigureSearch({
    preFilters,
    preFilterLogic,
    algoliaCategoryPath,
}: ConfigureProps) {
    return (
        <Configure
            facetingAfterDistinct
            filters={getConfigurationFilters(
                preFilters,
                preFilterLogic,
                algoliaCategoryPath
            )}
        />
    );
}
